module.exports = __webpack_public_path__ + "static/img/haeusle.0dad324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/haeusle.png
// module id = 474
// module chunks = 1